import type { PropsWithChildren, ReactElement } from 'react'

import './styles.scss'

const InputGroup = ({ children }: PropsWithChildren): ReactElement => {
  return <fieldset className="input-group-component">{children}</fieldset>
}

export default InputGroup
